import { BlotterTable, Box, columnTypes, useBlotterObservables, useBlotterTable } from '@talos/kyoko';
import { useMemo } from 'react';
import type { FundingRateGroupBy, FundingRateRow } from './FundingRateBlotter.types';
import { useFundingRateBlotterColumns } from './useFundingRateBlotterColumns';

interface FundingRateListViewProps {
  rows: FundingRateRow[];
  groupBy: FundingRateGroupBy;
  /** Current toolbar update-mode, resolved to its display label (e.g. "1H"/"1D") — shown in the Current Rate hover card. */
  periodLabel: string;
}

/** Flat, sortable list — one row per (asset, exchange). Snapshot data fed through a BehaviorSubject. */
export function FundingRateListView({ rows, groupBy, periodLabel }: FundingRateListViewProps) {
  const columns = useFundingRateBlotterColumns(groupBy, periodLabel);
  const { dataObservable, errorObservable } = useBlotterObservables({ data: rows });

  const autoGroupColumnDef = useMemo(() => columnTypes.group({ type: 'group', title: 'Group', editable: false }), []);

  const blotterTable = useBlotterTable<FundingRateRow>({
    dataObservable,
    errorObservable,
    columns,
    rowID: 'id' satisfies keyof FundingRateRow,
    gridOptions: {
      groupDisplayType: 'singleColumn',
      autoGroupColumnDef,
    },
  });

  return (
    <Box flex="1" w="100%" minHeight={0}>
      <BlotterTable {...blotterTable} data-testid="funding-rate-blotter-list" />
    </Box>
  );
}
